// Menu
import MobileMenu from "./Menu";

// Instantiate Menu
let mobileMenu = new MobileMenu();
if (module.hot) {
  module.hot.accept("./Menu.js", function() {
    mobileMenu.componentWillUnmount();
    mobileMenu = new MobileMenu();
  });
}

export default mobileMenu;
